import React from "react"
import styles from "./styles.scss"
import posed from "react-pose"
import Waypoint from "react-waypoint"
import card from "images/card.png"
import Reveal from "components/Reveal"
import ContactPerson from "./ContactPerson"
import rasmusImg from "./rasmus-face.jpg"
import danImg from "./dan-face.jpg"

const PosedContainer = posed.section({
  enter: { staggerChildren: 100, staggerDirection: -1 },
})

const PosedBubble = posed.div({
  enter: { scale: 1 },
  exit: { scale: 0 },
})

const PosedCard = posed.img({
  enter: { scale: 1 },
  exit: { scale: 0 },
})

const PosedText = posed.div({
  enter: { x: 0, opacity: 1 },
  exit: { x: 100, opacity: 0 },
})

class Contacts extends React.Component {
  state = { isOpen: false }

  handleScroll = () => this.setState({ isOpen: true })

  render() {
    return (
      <section className={styles.container} id="contact">
        <Reveal
          renderPose={revealed => (
            <PosedContainer
              className={styles.wrapper}
              initialPose="exit"
              pose={revealed ? "enter" : null}
            >
              <div className={styles.contactWrapper}>
                <PosedText className={styles.textContainer}>
                  <h2 className={styles.title}>
                    Kom i <span>kontakt</span> med oss
                  </h2>
                  <Waypoint onEnter={this.handleScroll} />

                  <p>
                    Har du eller ditt företag ett problem som behöver lösas?
                    Behöver ni utveckla en app, skapa en ny hemsida eller kanske
                    fräscha upp existerande produkter? Kontakta oss så gör vi en
                    analys av nuläget och skapar ett förslag på hur vi kan lösa
                    det åt er.
                  </p>

                  <div className={styles.contactAction}>
                    <ContactPerson
                      name="Rasmus Sandström"
                      position="VD"
                      email="rasmus@saits.se"
                      phoneNumber="+46 72 236 67 91"
                      image={rasmusImg}
                      className={styles.rasmusContact}
                    />
                    <ContactPerson
                      name="Dan Andréasson"
                      position="Utvecklingschef"
                      email="dan@saits.se"
                      phoneNumber="+46 70 304 06 19"
                      image={danImg}
                    />
                  </div>
                </PosedText>
                <div className={styles.circleContainer}>
                  <PosedCard src={card} className={styles.cardIcon} alt="" />
                  <PosedBubble className={styles.lowerCircle} />
                  <PosedBubble className={styles.upperCircle} />
                </div>
              </div>
            </PosedContainer>
          )}
        />
      </section>
    )
  }
}

export default Contacts



// WEBPACK FOOTER //
// ./src/components/Contact/index.jsx